// i18next returns the key path as a string when a key is missing — even
// with returnObjects:true — rather than undefined. That string is truthy,
// so a naive `t(key, { returnObjects: true }) || []` does not catch a
// missing key, and a later `.map()`/`.slice()` on the resulting string
// throws and can blank the whole page (React 18 unmounts on an uncaught
// render error with no boundary above it). These helpers coerce safely
// regardless of whether the key resolved.
export function tArray(t, key, options) {
  const value = t(key, { returnObjects: true, ...options });
  return Array.isArray(value) ? value : [];
}

export function tObject(t, key, options) {
  const value = t(key, { returnObjects: true, ...options });
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}
